import React from 'react';
import './header.scss';

function Header({ title, description }) {
  return (
    <div>
    { title ? 
      <div className="stepper-body-header-container">
        <div className="stepper-body-header-title">{title}</div>
        <div className="stepper-body-header-description">{description}</div>
      </div>
      :null
    }
    </div>
  );
}

export default Header;
